import { CreativeTypes } from '@bynder-studio/render-core';
import { gatewayClient, createService } from './connectors/httpClient';

export interface ComponentCollection {
    id: number;
    name: string;
}

interface GetComponentCollectionsParams {
    size: number;
    page: number;
    presetSearch?: string;
    collectionSearch?: string;
    sort?: [string, string];
    types?: CreativeTypes[];
}

export interface GetComponentCollectionsResponse {
    content: ComponentCollection[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: { empty: boolean; sorted: boolean; unsorted: boolean };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalElements: number;
    totalPages: number;
    first: boolean;
    size: number;
    number: number;
    sort: { empty: boolean; sorted: boolean; unsorted: boolean };
    numberOfElements: number;
    empty: boolean;
}

interface AddComponentCollectionRequest {
    name: string;
}

const httpClient = gatewayClient('/presets-collections');

const componentCollectionService = createService(httpClient, (client) => ({
    getComponentCollections({
        size,
        page,
        collectionSearch,
        presetSearch,
        sort,
        types,
    }: GetComponentCollectionsParams) {
        const params = new URLSearchParams({
            size: size.toString(),
            page: page.toString(),
        });

        if (collectionSearch) {
            params.append('collectionSearch', collectionSearch);
        }

        if (presetSearch) {
            params.append('presetSearch', presetSearch);
        }

        if (sort?.length) {
            params.append('sort', sort.join(','));
        }

        if (types?.length) {
            params.append('types', types.join(','));
        }

        return client.get<GetComponentCollectionsResponse>(`?${params.toString()}`);
    },

    addComponentCollection(data: AddComponentCollectionRequest) {
        return client.post<ComponentCollection>('', data);
    },

    deleteComponentCollection(id: number) {
        return client.delete(`/${id}`);
    },

    editComponentCollection(id: number, name: string) {
        return client.put<ComponentCollection>(`/${id}`, { name });
    },
}));

export default componentCollectionService;
